// src/components/SpectatorStats.jsx
import React, { useState, useMemo } from 'react';
import SpectatorStatsGeneral from './SpectatorStatsGeneral';

function SpectatorStats({ match, scoreEngineData }) {
  const [isExpanded, setIsExpanded] = useState(false);
  const [selectedSet, setSelectedSet] = useState(0); // 0 = match complet, 1 = set 1, etc.

  // 🆕 Mémoriser les points pour ne recalculer que si vraiment nécessaire
  const allPoints = useMemo(() => {
    // ✅ Priorité à scoreEngineData.points (temps réel), puis fallback sur match.engineState.points
    if (scoreEngineData?.points && scoreEngineData.points.length > 0) {
      return scoreEngineData.points;
    } else if (match?.engineState?.points && match.engineState.points.length > 0) {
      return match.engineState.points;
    }
    return [];
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    scoreEngineData?.points?.length,  // 🆕 Ne dépendre que du NOMBRE de points
    match?.engineState?.points?.length
  ]);

  // 🆕 Filtrer les points (mémorisé aussi)
  const filteredPoints = useMemo(() => {
    if (selectedSet === 0) {
      return allPoints;
    }
    return allPoints.filter(p => p.setNumero === selectedSet);
  }, [allPoints, selectedSet]);

  if (!match) return null;

  const playerNames = {
    joueur1: match.prenomJoueur1 || match.joueur1Nom || 'Joueur 1',
    joueur2: match.prenomJoueur2 || match.joueur2Nom || 'Joueur 2'
  };

  const matchFormat = match.formatMatch || 'BEST_OF_3';
  const isBestOf5 = matchFormat === 'BEST_OF_5';

  return (
    <div style={{
      maxWidth: '600px',
      margin: '20px auto',
      backgroundColor: 'rgba(255, 255, 255, 0.95)',
      borderRadius: '12px',
      boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)',
      overflow: 'hidden'
    }}>
      {/* Header cliquable */}
      <button
        onClick={() => setIsExpanded(!isExpanded)}
        style={{
          width: '100%',
          padding: '16px',
          backgroundColor: '#1976D2',
          color: 'white',
          border: 'none',
          fontSize: '16px',
          fontWeight: '600',
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          transition: 'background-color 0.3s'
        }}
        onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#1565C0'}
        onMouseOut={(e) => e.currentTarget.style.backgroundColor = '#1976D2'}
      >
        <span>📊 STATISTIQUES EN DIRECT</span>
        <span style={{ fontSize: '20px' }}>{isExpanded ? '▼' : '▶'}</span>
      </button>

      {/* Contenu déplié */}
      {isExpanded && (
        <div style={{ padding: '16px' }}>
          {/* Filtres par set - TOUJOURS AFFICHÉS */}
          <div style={{
            display: 'flex',
            gap: '4px',
            marginBottom: '16px',
            overflowX: 'auto',
            borderBottom: '2px solid #e0e0e0'
          }}>
            <button
              onClick={() => setSelectedSet(0)}
              style={{
                padding: '8px 12px',
                border: 'none',
                borderBottom: selectedSet === 0 ? '3px solid #1976d2' : '3px solid transparent',
                backgroundColor: 'transparent',
                color: selectedSet === 0 ? '#1976d2' : '#666',
                fontWeight: selectedSet === 0 ? '700' : '600',
                fontSize: isBestOf5 ? '10px' : '11px',
                cursor: 'pointer',
                whiteSpace: 'nowrap',
                textTransform: 'lowercase'
              }}
            >
              match complet
            </button>
            {[1, 2, 3].map(setNum => (
              <button
                key={setNum}
                onClick={() => setSelectedSet(setNum)}
                style={{
                  padding: '8px 12px',
                  border: 'none',
                  borderBottom: selectedSet === setNum ? '3px solid #1976d2' : '3px solid transparent',
                  backgroundColor: 'transparent',
                  color: selectedSet === setNum ? '#1976d2' : '#666',
                  fontWeight: selectedSet === setNum ? '700' : '600',
                  fontSize: isBestOf5 ? '10px' : '11px',
                  cursor: 'pointer',
                  whiteSpace: 'nowrap',
                  textTransform: 'lowercase'
                }}
              >
                set {setNum}
              </button>
            ))}
            {isBestOf5 && [4, 5].map(setNum => (
              <button
                key={setNum}
                onClick={() => setSelectedSet(setNum)}
                style={{
                  padding: '8px 12px',
                  border: 'none',
                  borderBottom: selectedSet === setNum ? '3px solid #1976d2' : '3px solid transparent',
                  backgroundColor: 'transparent',
                  color: selectedSet === setNum ? '#1976d2' : '#666',
                  fontWeight: selectedSet === setNum ? '700' : '600',
                  fontSize: '10px',
                  cursor: 'pointer',
                  whiteSpace: 'nowrap',
                  textTransform: 'lowercase'
                }}
              >
                set {setNum}
              </button>
            ))}
          </div>

          {/* Message si pas de stats pour ce set */}
          {filteredPoints.length === 0 && (
            <div style={{ 
              textAlign: 'center', 
              padding: '20px', 
              color: '#999',
              fontSize: '13px',
              backgroundColor: '#f5f5f5',
              borderRadius: '8px'
            }}>
              {selectedSet === 0 ? (
                <>Aucun point joué pour le moment</>
              ) : (
                <>Aucun point joué dans le set {selectedSet}</>
              )}
            </div>
          )}

          {/* Stats générales */}
          {filteredPoints.length > 0 && (
            <SpectatorStatsGeneral 
              allPoints={filteredPoints}
              playerNames={playerNames}
            />
          )}
        </div>
      )}
    </div>
  );
}

export default SpectatorStats;